import React from 'react';
import wrap from 'wraptile';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {compose, getFrom, isEqual, not} from '@pluto/utils';
import {ArtworkItem} from './QCToolsArtworkTypes&Const';

export interface ControlArrowsProps {
    images: ArtworkItem[];
    currentId: number;
    onActiveImgChangeCurried: (image: number) => any;
}

export const handleArrowClick = wrap(
    (onActiveImgChangeCurried: (id: number) => void, id: number) => {
        onActiveImgChangeCurried(id);
    }
);

export const mapArtworkImages = (item: ArtworkItem) => item.id;

const filterOutStatuses = compose(not(Boolean), not(isEqual('DONE')), getFrom('status'));

export const ControlArrows = (props: ControlArrowsProps) => {
    const {images, currentId, onActiveImgChangeCurried} = props;
    const ids = images.filter(filterOutStatuses).map(mapArtworkImages);

    const lastIndex = ids.length - 1;
    const currentImageIndex = ids.indexOf(currentId);

    const previousIndex = currentImageIndex > 0 ? currentImageIndex - 1 : 0;
    const nextIndex = currentImageIndex === lastIndex ? lastIndex : currentImageIndex + 1;

    const prevId = ids[previousIndex];
    const nextId = ids[nextIndex];

    const handleBackClick = handleArrowClick(onActiveImgChangeCurried, prevId);
    const handleForwardClick = handleArrowClick(onActiveImgChangeCurried, nextId);

    return (
        <>
            {currentImageIndex > 0 && (
                <div className="control-button control-button_previous">
                    <ArrowBackIosIcon onClick={handleBackClick} />
                </div>
            )}
            {currentImageIndex < lastIndex && (
                <div className="control-button control-button_next">
                    <ArrowForwardIosIcon onClick={handleForwardClick} />
                </div>
            )}
        </>
    );
};

export default ControlArrows;
